import ActionTypes from '@constants/action_types.js'

export function receiveEndpoints(endpoints) {
  return {
    type: ActionTypes.RECEIVE_ENDPOINTS,
    payload: endpoints,
  }
}
